import React, { useRef, useState } from 'react';

interface Card3DProps {
  children: React.ReactNode;
  className?: string;
  intensity?: number;
}

const Card3D: React.FC<Card3DProps> = ({ 
  children, 
  className = '',
  intensity = 20 // Contrôle l'intensité de l'effet 3D
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;

    const rect = cardRef.current.getBoundingClientRect();
    
    // Calcul de la position relative de la souris dans la carte (de -0.5 à 0.5)
    const relativeX = (e.clientX - rect.left) / rect.width - 0.5;
    const relativeY = (e.clientY - rect.top) / rect.height - 0.5;

    // Calcul des angles de rotation avec mouvement diagonal
    const rotateX = -relativeY * intensity; // Inverse pour un mouvement naturel
    const rotateY = relativeX * intensity;

    setRotation({ 
      x: rotateX,
      y: rotateY
    });
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setRotation({ x: 0, y: 0 });
  };

  const style = {
    transform: isHovered 
      ? `
        perspective(1000px) 
        rotateX(${rotation.x}deg) 
        rotateY(${rotation.y}deg)
        scale3d(1.05, 1.05, 1.05)
      `
      : 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
    transition: isHovered 
      ? 'transform 0.1s ease' 
      : 'transform 0.3s ease-out',
    transformStyle: 'preserve-3d' as const
  };

  return (
    <div
      ref={cardRef}
      className={`relative will-change-transform ${className}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={style}
    >
      {/* Effet de brillance qui suit la souris */}
      {isHovered && (
        <div 
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'radial-gradient(circle at var(--mouse-x) var(--mouse-y), rgba(255,255,255,0.15), transparent 80%)',
            '--mouse-x': `${(rotation.y / intensity + 0.5) * 100}%`,
            '--mouse-y': `${(rotation.x / -intensity + 0.5) * 100}%`
          } as React.CSSProperties}
        />
      )}
      {children}
    </div>
  );
};

export default Card3D;